// removed by extract-text-webpack-plugin
module.exports = {"contentPlaceholder":"_32LBdSVCMeKQmUvwyO64GJ","box":"_3CEKoAkGf4qjfAx5RCrG9L","circle":"_3mm9u3DgYgia3Uhx2xcbs-","line":"_2-c8pzNyJPwdBl4dhkGuzV","header":"_3u2KGeYdGBosD3LIKQoq1H","blink":"_26uyAhrWRgHw3q3rG3awsp"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/atoms/Placeholder/style.module.css
// module id = 474
// module chunks = 38